<template>
  <v-col
    v-if="$vuetify.breakpoint.name == 'xs'"
    cols="12"
    class="pa-0 align-center"
    style="height: 100vh;display: flex;margin-top: -70px;"
  >

    <h2 class="text-center">
      <v-icon x-large class="mb-5">mdi-phone-rotate-landscape</v-icon>
      <br />
      Put your phone in landscape mode
    </h2>
  </v-col>
  <v-col v-else cols="12" class="pa-0">
    <v-tabs
      :loading="loading"
      vertical
      class="report-tabs-panel"
      v-model="reportsTabModel">

      <v-list
        width="200px"
        :height="`calc(100vh - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
        dense
        :expand="options.expand"
        style="overflow-y: hidden"
      >
        <v-list-group
          v-for="(type, kIndex) in reportsByType"
          no-action
          :value="kIndex == 0 || options.expandAll"
          :key="type.type"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="type.type" />
            </v-list-item-content>
          </template>

          <v-tab
            v-for="(report, index) in type.list"
            v-bind:key="report.alias"
            v-bind:index="report.alias"
            v-html="report.name"
          />
        </v-list-group>
      </v-list>

      <v-tabs-items touchless v-model="reportsTabModel" style="width: calc(100% - 200px)">

        <template v-for="(type, kIndex) in reportsByType">
          <v-tab-item
            v-for="(report, index) in type.list"
            v-bind:key="report.alias"
            v-bind:index="report.alias"
          >
            <component :is="(report.dist || 'default-report')" :projectList="projectList" :title="report.name" :url="report.url" :headers="report.headers" :defaultParams="report.defaultParams" :options="report.options" :filters="report.filters || []"></component>
          </v-tab-item>
        </template>

      </v-tabs-items>
    </v-tabs>
  </v-col>
</template>

<style>
  .report-tabs-panel {
    /*display: -webkit-box;*/
  }

  .report-tabs-panel .v-list-group,
  .report-tabs-panel .v-list-group__items {
    border-top: 1px solid #c0c1c2;
  }

  .report-tabs-panel .v-list-group__items {
    border-top: 1px solid #c0c1c2;
  }

  .report-tabs-panel .v-list-group:last-child {
    border-bottom: none;
  }

  .report-tabs-panel .v-list-item__icon {
    min-width: 24px !important;
    margin-left: 5px;
  }
</style>

<script>
  import { toArray, reduce, get } from 'lodash'
  import { API } from '@/utils/api'

  export default {
    data: () => ({
      expand: [ true, false, false ],
      dateRangeList,
      reportsTabModel: null,
      projectList: [],
      reports: [],
      loading: true,
      options: {
        expand: true,
        expandAll: true
      }
    }),

    components: {
      DefaultReport: () => import('@/components/report/Default'),
      CashbackCalc: () => import('@/components/report/CashbackCalc'),
      Betslip: () => import('@/components/report/Betslip'),
      ProfitByKiosk: () => import('@/components/report/ProfitByKiosk')
    },
    computed: {
      reportsByType: function () {
        return toArray(reduce(this.reports, (r, o, i) => {
          if (!r[o.type]) {
            r[o.type] = { type: o.type, list: [], expand: i == 0 }
          }
          r[o.type]['list'].push(o)
          return r
        }, {}))
      }
    },

    methods: {

      loadReportList () {
        return API.call('/kiosk/reports/list.json', {}, null, null).then(resp => {
          this.projectList = get(resp, 'projectList', [])

          this.reports = get(resp, 'data', [])

          return resp.data
        }).catch(e => {
        }).finally(() => {
          this.loading = false
        })
      },

      updateExpand: function (kIndex) {
        this.$set(this.expand, kIndex, !this.expand[kIndex])
      },
    },

    mounted () {

      this.loadReportList()

      let _this = this
      setTimeout(function () {
        _this.options.expand = false
        _this.options.expandAll = false
      }, 1000)

    },
  }
</script>
